import clsx from 'clsx'
import type { ReactNode } from 'react'

interface LandingSectionProps {
  id?: string
  title: string
  subtitle?: string
  children: ReactNode
  className?: string
  centered?: boolean
}

export function LandingSection({
  id,
  title,
  subtitle,
  children,
  className,
  centered = false,
}: LandingSectionProps) {
  return (
    <section id={id} className={clsx('px-4 py-16 sm:px-8 sm:py-20', className)}>
      <div className={clsx('mx-auto max-w-6xl', centered && 'text-center')}>
        <h2 className="text-2xl font-bold tracking-tight text-text-primary sm:text-3xl">{title}</h2>
        {subtitle ? (
          <p
            className={clsx(
              'mt-4 max-w-3xl text-base leading-relaxed text-text-secondary sm:text-lg',
              centered && 'mx-auto',
            )}
          >
            {subtitle}
          </p>
        ) : null}
        <div className={subtitle ? 'mt-10' : 'mt-8'}>{children}</div>
      </div>
    </section>
  )
}
